<template>
  <v-container fluid fill-height>
    <v-layout justify-center>
      <v-flex text-xs-center>
        <template>
          <v-card>
            <v-card-title>
              <div class="title">{{ pagename }}</div>

              <v-spacer></v-spacer>

              <v-text-field
                v-model="search"
                append-icon="search"
                label="Buscar..."
                single-line
                hide-details
              ></v-text-field>
              <v-dialog v-model="dialog" fullscreen persistent>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark class="mb-2" v-on="on"
                    >Nuevo Solicitante</v-btn
                  >
                </template>
                <v-card>
                  <v-form
                    ref="formApplicant"
                    v-model="validForm"
                    lazy-validation
                  >
                    <v-card-title class="primary white--text">
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 sm6 md6>
                            <v-text-field
                              v-model="editedItem.nombre_solicitante"
                              label="Nombre Solicitante"
                              background-color="tertiary"
                              color="primary"
                              :rules="requireRules"
                              autofocus
                              box
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <v-text-field
                              v-model="editedItem.apellido_solicitante"
                              label="Apellidos Solicitante"
                              background-color="tertiary"
                              color="primary"
                              :rules="requireRules"
                              box
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-text-field
                              v-model="editedItem.correo_solicitante"
                              label="Correo Solicitante"
                              background-color="tertiary"
                              color="primary"
                              :rules="emailRules"
                              box
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="gray darken-1" flat @click="close"
                        >Cancelar</v-btn
                      >
                      <v-btn
                        color="primary darken-1"
                        @click="save"
                        :disabled="!validForm"
                        :loading="loading"
                        >Guardar</v-btn
                      >
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-dialog>
            </v-card-title>

            <v-data-table
              :headers="headers"
              :items="desserts"
              class="elevation-1"
              :loading="loading"
              :search="search"
              :pagination.sync="pagination"
            >
              <!-- :search="search" -->
              <template v-slot:items="props">
                <td class="text-xs-left">
                  {{ props.item.nombre_solicitante }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.apellido_solicitante }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.correo_solicitante }}
                </td>
                <td class="text-xs-left">
                  {{ formatoTiempo(props.item.fecha_registro) }}
                </td>
                <td class="justify-center layout px-0">
                  <!-- <v-icon
                      small
                      class="mr-2"
                    >
                      photo_library
                    </v-icon> -->
                  <v-icon small class="mr-2" @click="editItem(props.item)">
                    edit
                  </v-icon>
                  <v-icon small @click="deleteItem(props.item)">
                    delete
                  </v-icon>
                </td>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">Recargar</v-btn>
              </template>
            </v-data-table>
          </v-card>
        </template>
      </v-flex>
    </v-layout>

    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn flat @click="snack = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import { bus } from "./../main";
var moment = require("moment");
var configBaseAxios = {
  timeout: 10000,
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "x-www-form-urlencoded",
  },
  params: {},
};
export default {
  mounted() {
    this.loading = true;
    // console.log('mounted')
    // console.log('$route.params', this.$route.params.carrera_id)
    this.logged_user = JSON.parse(localStorage.getItem("logged_user"));

    if (this.logged_user && this.logged_user.id_perfil == 4) {
      this.$router.push({ name: "Find" });
    }

    this.initialize();
  },
  data: (vm) => ({
    pagename: "ODONTÓLOGOS",
    logged_user: null,
    dialog: false,
    loading: false,
    snack: false,
    snackColor: "",
    snackText: "",
    search: "",
    pagination: {
      sortBy: "fecha_registro",
      descending: true,
    },
    headers: [
      { text: "Nombres", sortable: false, value: "nombre_solicitante" },
      { text: "Apelllidos", sortable: false, value: "apellido_solicitante" },
      { text: "Correo", sortable: false, value: "correo_solicitante" },
      { text: "Creado", sortable: false, value: "fecha_registro" },
      { text: "Acciones", sortable: false },
    ],
    desserts: [],
    validForm: false,
    editedIndex: -1,
    editedItem: {
      nombre_solicitante: "",
      apellido_solicitante: "",
      correo_solicitante: "",
    },
    defaultItem: {
      nombre_solicitante: "",
      apellido_solicitante: "",
      correo_solicitante: "",
    },
    requireRules: [(v) => !!v || "Campo es requerido"],
    emailRules: [
      (v) => !!v || "Correo es requerido",
      (v) => /.+@.+/.test(v) || "El correo debe ser válido",
    ],
    fonoRules: [
      (v) => !!v || "Campo es requerido",
      (v) => (!!v && v.length == 9) || "El fono debe ser válido",
    ],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Nuevo Solicitante"
        : "Editar Solicitante";
    },
  },

  watch: {},

  created() {
    // console.log('created')
    //this.initialize()
  },

  methods: {
    initialize() {
      Promise.all([this.getSolicitantes()])
        .then(() => {
          // console.log('promesa lista')
          // this.initForm()
        })
        .catch((reason) => {
          // console.log('Fail', reason)
          setTimeout(() => {
            bus.$emit("userStatus", {
              isLogged: false,
              message: "Sesión de usuario finalizada",
            });
          }, 1000);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getSolicitantes() {
      return new Promise((resolve, reject) => {
        configBaseAxios.params = {
          accion: "solicitantes",
          opcion: "listarSolicitante",
          api_token: this.logged_user.api_token,
        };
        axios
          .create(configBaseAxios)
          .get(window.base_path + window.ws)
          .then((result) => {
            if (result.data.response) {
              this.desserts = result.data.callback;
              resolve();
            } else {
              reject("No data result");
            }
          })
          .catch((error) => {
            reject("Error ajax");
          });
      });
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      // const index = this.desserts.indexOf(item)
      // confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
      const index = this.desserts.indexOf(item);
      //confirm('¿Está seguro que desea eliminar este usuario?') //&& this.usuarios.splice(index, 1)
      if (
        confirm(
          '¿Está seguro que desea eliminar este solicitante: "' +
            item.nombre_solicitante +
            '"?'
        )
      ) {
        axios({
          method: "post",
          withCredentials: true,
          url: window.base_path + window.ws,
          data: {
            api_token: this.logged_user.api_token,
            accion: "solicitantes",
            opcion: "borrarSolicitante",
            id_solicitante: item.id_solicitante,
          },
        })
          .then((result) => {
            // console.log(result)
            if (result.data.response) {
              this.snackColor = "success";
              this.snackText = result.data.mensaje;
              this.desserts.splice(index, 1);
            } else {
              this.snackColor = "error";
              this.snackText = result.data.mensaje;
            }
            this.snack = true;
          })
          .catch((error) => {
            // console.log('error',error)
            this.snackColor = "error";
            this.snackText = error.response;
            this.snack = true;
            //setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
          });
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.$refs.formApplicant.reset();
      }, 300);
    },

    formatFono(fono) {
      // 12 345 6789
      // 01 234 5678

      let codigoArea = fono.substr(0, 2);
      let fonoA = fono.substr(2, 3);
      let fonoB = fono.substr(5, fono.length - 5);
      return "(" + codigoArea + ") " + fonoA + " " + fonoB;
    },

    formatoTiempo(time) {
      return moment(time)
        .locale("es")
        .fromNow();
    },

    save() {
      if (this.$refs.formApplicant.validate()) {
        const contentData = {
          accion: "solicitantes",
          opcion:
            this.editedIndex > -1 ? "editarSolicitante" : "nuevoSolicitante",
          id_solicitante:
            this.editedIndex > -1 ? this.editedItem.id_solicitante : null,
          nombreSolicitante: this.editedItem.nombre_solicitante,
          apellidoSolicitante: this.editedItem.apellido_solicitante,
          correoSolicitante: this.editedItem.correo_solicitante,
          estado: 1,
          api_token: this.logged_user.api_token,
        };

        // console.log('contentData', JSON.parse(JSON.stringify(contentData)))

        axios({
          method: "post",
          withCredentials: true,
          url: window.base_path + window.ws,
          data: contentData,
        })
          .then((result) => {
            // console.log('result modificar examen', contentData, JSON.parse(JSON.stringify(result)))
            this.snackText = result.data.mensaje;
            if (result.data.response) {
              this.snackColor = "success";
              if (this.editedIndex > -1) {
                Object.assign(this.desserts[this.editedIndex], this.editedItem);
              } else {
                this.editedItem.id_solicitante = result.data.id_solicitante;
                this.desserts.push(this.editedItem);
              }
            } else {
              this.snackColor = "error";
            }
            this.snack = true;
          })
          .catch((error) => {
            // console.log('error',error)
            this.snackColor = "error";
            this.snackText = error.response;
            this.snack = true;
            setTimeout(() => {
              bus.$emit("userStatus", {
                isLogged: false,
                message: "Sesión de usuario finalizada",
              });
            }, 1000);
          })
          .finally(() => {
            this.close();
          });
      }
    },
  },
};
</script>
